const domainUUIDByMGDB = {
  v1: {
    bacteria: '776a2dad-8512-4cfa-93e3-a574a97478ef',
    yeast: '7114a8d9-45f2-4c36-9a46-2bfd7d1a9f0b',
    archaea: 'c02c3f35-ac7f-43fa-bfa5-aa6c6d6ba9e7'
  },
  v2: {
    bacteria: '625f796c-81a1-4859-8836-366e97148462',
    yeast: '25b54546-a29e-4f56-a3a7-468da6e86d3b',
    archaea: '44dceeae-4157-46aa-a649-f57eb2ab4ad8'
  }
}
export default domainUUIDByMGDB
